<template>
  <div
    class="navbar-container d-flex content align-items-center"
    style="margin-bottom: -0.5rem;margin-top: -0.5rem;"
  >
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <empresa-externa v-if="isExternalAuthenticated()" />

    <b-navbar-nav v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()">
      <b-nav-item :to="'/tela-favoritos'">
        <div style="display:flex;align-items:center;">
          <feather-icon
            icon="StarIcon"
            style="margin-right:0.5rem;color:var(--primary);"
          />
          {{ currentRouteName === 'tela-favoritos' ? 'Favoritos' : 'Acessar favoritos' }}
        </div>
      </b-nav-item>

      <!-- Botão Nova Proposta ao lado de "Acessar favoritos" -->
      <cadastro-proposta
        v-if="mostrarBotaoNovaProposta"
        class="ml-1 botao-nova-proposta"
      />
    </b-navbar-nav>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <div v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()">
        <span style="float:left;margin-top:10px;">Seleção de módulo :</span>

        <div class="tag-modulo">
          <b-nav-item-dropdown
            toggle-class="d-flex align-items-center dropdown-user-link"
            class="dropdown-user"
          >
            <template #button-content>
              <div class="d-sm-flex d-none">
                <b-img
                  :src="imgModulo"
                  height="40px"
                  width="40px"
                  rounded="circle"
                />
                <div
                  v-if="imgModulo == imgComercial"
                  class="modulo-letra"
                >
                  Comercial
                </div>
                <div
                  v-if="imgModulo == imgCobranca"
                  class="modulo-letra"
                >
                  Cobrança
                </div>
                <div
                  v-if="imgModulo == imgPlataforma"
                  class="modulo-letra"
                >
                  Plataforma
                </div>
                <div class="chevronicon">
                  <feather-icon
                    size="20"
                    icon="ChevronDownIcon"
                    class="mr-50"
                  />
                </div>
              </div>
            </template>

            <b-dropdown-item
              v-if="modulos.includes('Cobrança')"
              link-class="d-flex align-items-center"
              class="cobranca-color"
              @click="alterarModulo('Cobrança')"
            >
              <div style="margin-left:0;">
                <b-img
                  :src="imgCobranca"
                  height="25px"
                  width="25px"
                />
                <span>Cobrança</span>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="modulos.includes('Comercial')"
              link-class="d-flex align-items-center"
              class="comercial-color"
              @click="alterarModulo('Comercial')"
            >
              <div style="margin-left:0;">
                <b-img
                  :src="imgComercial"
                  height="25px"
                  width="25px"
                />
                <span>Comercial</span>
              </div>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="modulos.includes('Plataforma')"
              link-class="d-flex align-items-center"
              class="plataforma-color"
              @click="alterarModulo('Plataforma')"
            >
              <div style="margin-left:0;">
                <b-img
                  :src="imgPlataforma"
                  height="25px"
                  width="25px"
                />
                <span>Plataforma</span>
              </div>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div>
      </div>

      <!-- Dark Mode Toggle -->
      <dark-toggler
        v-if="!isAccessNotAuthenticated()"
        class="d-none d-lg-block"
      />

      <b-nav-item-dropdown
        v-if="!isAccessNotAuthenticated()"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ getNome() }}
            </p>
            <span class="user-status">{{ getGrupo() }}</span>
          </div>
        </template>

        <b-dropdown-item
          v-if="!isExternalAuthenticated()"
          link-class="d-flex align-items-center"
          @click="goProfile"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Meu perfil</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>

      <b-nav-item
        v-else
        right
        class="dropdown-user"
      >
        <template>
          <p
            class="user-name font-weight-bolder mb-0"
            style="text-align:right;"
          >
            {{ getNome() }}
          </p>
          <span class="user-status">{{ getEmail() }}</span>
        </template>
      </b-nav-item>
    </b-navbar-nav>

    <b-button
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      variant="link"
      class="d-flex align-items-center p-0 notification-button"
      @click="openNotificationsDrawer"
    >
      <div style="position:relative;">
        <feather-icon
          icon="BellIcon"
          size="20"
          class="mr-50"
        />
        <span
          v-if="unreadNotificationCount > 0"
          style="
            position:absolute; top:-5px; right:-5px;
            background-color:red; color:white; border-radius:50%;
            padding:2px 6px; font-size:0.8rem; font-weight:bold;
          "
        >
          {{ unreadNotificationCount > 9 ? '9+' : unreadNotificationCount }}
        </span>
      </div>
    </b-button>

    <NotificationsDrawer
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      :is-drawer-visible.sync="isDrawerVisible"
      :has-notifications="hasNotifications"
      :notification-count="notificationCount"
      :notifications="notifications"
      @open-notification-modal="openNotificationModal"
      @notification-drawer-closed="checkUnreadNotifications"
    />

    <div
      v-if="!isExternalAuthenticated() && !isAccessNotAuthenticated()"
      @open-notification-modal="openNotificationModal"
    >
      <NotificationModal
        v-if="selectedNotification"
        :notification="selectedNotification"
        :show="isNotificationModalVisible"
        @close-notification-modal="closeNotificationModal"
      />
    </div>
  </div>
</template>

<style lang="scss">
.chevronicon {
  align-self: center;
  color: #6b6b6b;
  margin-right: -7px;
  margin-left: 5px;
}

.modulo-letra {
  color: var(--primary) !important;
  font-weight: bold;
  padding: 4px !important;
  align-self: center;
  margin-left: -2px;
}

.tag-modulo {
  margin-left: 5px;
  border: 0.8px solid var(--primary) !important;
  background-color: transparent;
  color: var(--primary) !important;
  padding-bottom: 4px !important;
  display: inline-flex;
  font-weight: bold;
  border-radius: 6px;
}

.dropdown-menu li.comercial-color a:hover {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #00cc66 !important;
}

.dropdown-menu li.comercial-color a:focus {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #00cc66 !important;
}

.dropdown-menu li.comercial-color a:active {
  background-color: #00cc66 !important;
  color: white !important;
}

.dropdown-menu li.plataforma-color a:hover {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #276DFC !important;
}

.dropdown-menu li.plataforma-color a:focus {
  background-color: rgba(0, 204, 102, 0.1) !important;
  color: #276DFC !important;
}

.dropdown-menu li.plataforma-color a:active {
  background-color: #276DFC !important;
  color: white !important;
}

.dropdown-menu li.cobranca-color a:hover {
  background-color: rgba(193, 175, 29, 0.1) !important;
  color: #c1af1d !important;
}

.dropdown-menu li.cobranca-color a:focus {
  background-color: rgba(193, 175, 29, 0.1) !important;
  color: #c1af1d !important;
}

.dropdown-menu li.cobranca-color a:active {
  background-color: #c1af1d !important;
  color: white !important;
}

.color-icon-action {
  color: var(--primary);
  cursor: pointer;
}
</style>

<script>
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { nextTick } from '@vue/composition-api'
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BImg, BButton,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import {
  getUserInfo, isExternalAccess, getModulos, isAccessNotAuthenticated, isUserLoggedIn,
} from '@/auth/utils'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'
import EmpresaExterna from './EmpresaExterna.vue'
import NotificationsDrawer from './NotificationsDrawer.vue'
import NotificationModal from './NotificationModal.vue'

const srcCobranca = require('@/assets/images/modulos/cobranca.png')
const srcComercial = require('@/assets/images/modulos/comercial.png')
const srcPlataforma = require('@/assets/images/modulos/plataforma.png')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BImg,
    BButton,
    DarkToggler,
    EmpresaExterna,
    NotificationsDrawer,
    NotificationModal,
    cadastroProposta: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      imgModulo: srcCobranca,
      imgCobranca: srcCobranca,
      imgComercial: srcComercial,
      imgPlataforma: srcPlataforma,
      modulos: [],
      isDrawerVisible: false,
      hover: null,
      hasNotifications: true,
      notificationCount: 0,
      notifications: [],
      selectedNotification: null,
      isNotificationModalVisible: true,
      unreadNotificationCount: 0,
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    // mostra o botão apenas quando o módulo selecionado é Comercial
    mostrarBotaoNovaProposta() {
      return localStorage.moduloSelecionado === 'Comercial'
    },
    ...mapState({
      isMenuCollapsed: state => state.verticalMenu.isVerticalMenuCollapsed,
    }),
  },
  created() {
    this.modulos = getModulos()

    const moduloInicial = (localStorage.moduloSelecionado && this.modulos.includes(localStorage.moduloSelecionado))
      ? localStorage.moduloSelecionado
      : (this.modulos && this.modulos[0])

    if (moduloInicial) {
      this.setTemaModulo(moduloInicial)
    }
  },
  mounted() {
    this.fetchNotifications()
    setInterval(this.checkUnreadNotifications, 190000)
  },
  methods: {
    // aplica classe de módulo no <body> para o degradê do header
    updateBodyModulo(modulo) {
      const { body } = document
      const classesModulo = ['modulo-comercial', 'modulo-cobranca', 'modulo-plataforma']

      body.classList.remove(...classesModulo)

      if (modulo === 'Comercial') {
        body.classList.add('modulo-comercial')
      } else if (modulo === 'Cobrança') {
        body.classList.add('modulo-cobranca')
      } else if (modulo === 'Plataforma') {
        body.classList.add('modulo-plataforma')
      }
    },
    setTemaModulo(modulo) {
      if (modulo === 'Cobrança') {
        this.imgModulo = this.imgCobranca
        document.querySelector(':root').style.setProperty('--primary', '#c1af1d')
        document.querySelector(':root').style.setProperty('--primary-rgb', '193, 175, 29')
        localStorage.setItem('moduloSelecionado', 'Cobrança')
      } else if (modulo === 'Plataforma') {
        this.imgModulo = this.imgPlataforma
        document.querySelector(':root').style.setProperty('--primary', '#276DFC')
        document.querySelector(':root').style.setProperty('--primary-rgb', '75, 24, 255')
        localStorage.setItem('moduloSelecionado', 'Plataforma')
      } else {
        this.imgModulo = this.imgComercial
        document.querySelector(':root').style.setProperty('--primary', '#00cc66')
        document.querySelector(':root').style.setProperty('--primary-rgb', '0, 204, 102')
        localStorage.setItem('moduloSelecionado', 'Comercial')
      }

      // garante que o body receba a classe correta no carregamento inicial
      this.updateBodyModulo(modulo)
    },
    logout() {
      if (this.$router.history.current.path.indexOf('portal-clientes') > 0) {
        this.$router.push({ name: 'portalcliente-login' })
      } else {
        this.$router.push({ name: 'auth-login' })
      }
    },
    goProfile() {
      this.$router.push({ name: 'perfil' })
    },
    getNome() {
      return getUserInfo().nome
    },
    getGrupo() {
      return getUserInfo().grupo
    },
    getEmail() {
      return getUserInfo().email
    },
    isExternalAuthenticated() {
      return isExternalAccess() && !isAccessNotAuthenticated()
    },
    isAccessNotAuthenticated() {
      return isAccessNotAuthenticated()
    },
    alterarModulo(modulo) {
      if (modulo === 'Cobrança') {
        this.imgModulo = this.imgCobranca
        document.querySelector(':root').style.setProperty('--primary', '#c1af1d')
        document.querySelector(':root').style.setProperty('--primary-rgb', '193, 175, 29')
        localStorage.setItem('moduloSelecionado', 'Cobrança')
        const destino = { name: 'portaldocumentos-inerno' }
        const navegar = this.$route.name !== destino.name ? this.$router.push(destino).catch(() => { }) : Promise.resolve()
        Promise.resolve(navegar).finally(async () => {
          await nextTick()
          window.dispatchEvent(new CustomEvent('update-menu', { detail: { modulo: 'Cobrança' } }))
        })
      } else if (modulo === 'Plataforma') {
        this.imgModulo = this.imgPlataforma
        document.querySelector(':root').style.setProperty('--primary', '#276DFC')
        document.querySelector(':root').style.setProperty('--primary-rgb', '75, 24, 255')
        localStorage.setItem('moduloSelecionado', 'Plataforma')
        const destino = { name: 'plataforma-dashboard' }
        const navegar = this.$route.name !== destino.name ? this.$router.push(destino).catch(() => { }) : Promise.resolve()
        Promise.resolve(navegar).finally(async () => {
          await nextTick()
          window.dispatchEvent(new CustomEvent('update-menu', { detail: { modulo: 'Plataforma' } }))
        })
      } else {
        this.imgModulo = this.imgComercial
        document.querySelector(':root').style.setProperty('--primary', '#00cc66')
        document.querySelector(':root').style.setProperty('--primary-rgb', '0, 204, 102')
        localStorage.setItem('moduloSelecionado', 'Comercial')
        const destino = { name: 'painel-proposta' }
        const navegar = this.$route.name !== destino.name ? this.$router.push(destino).catch(() => { }) : Promise.resolve()
        Promise.resolve(navegar).finally(async () => {
          await nextTick()
          window.dispatchEvent(new CustomEvent('update-menu', { detail: { modulo: 'Comercial' } }))
        })
      }

      // aplica classe no <body> sempre que trocar o módulo
      this.updateBodyModulo(modulo)
    },
    openNotificationsDrawer() {
      this.fetchNotifications()
      this.isDrawerVisible = false
      this.$nextTick(() => { this.isDrawerVisible = true })
    },
    async fetchNotifications() {
      if (!isUserLoggedIn()) return
      if (isExternalAccess() || isAccessNotAuthenticated()) return
      const filtros = {}
      const response = await api.getNotificacoesUsuario(1, 10, filtros)
      this.notifications = response.data.notificacoes
      this.notificationCount = this.notifications.length
      this.unreadNotificationCount = this.notifications.filter(n => !n.visualizada).length
      this.hasNotifications = this.notifications.length > 0
    },
    async checkUnreadNotifications() {
      if (!isUserLoggedIn()) return
      if (isExternalAccess() || isAccessNotAuthenticated()) return
      const response = await api.getNotificacoesUsuarioNaoLidas()
      this.unreadNotificationCount = response.data
    },
    openNotificationModal(notification) {
      this.selectedNotification = notification
      this.isNotificationModalVisible = true
    },
    closeNotificationModal() {
      this.selectedNotification = null
      this.isNotificationModalVisible = false
    },
  },
}
</script>
<style>
  .botao-nova-proposta {
  margin-top: -4px;
}

</style>
